<template>
  <fieldset>
    <div v-for="(contact, idx) in contacts" :key="idx">
      <div class="d-flex justify-content-between align-items-baseline mt-2 mb-3">
        <h5>Signatör {{2 + idx}}</h5>
        <button type="button" class="btn btn-sm btn-secondary" @click="deleteContact(idx)"><i class="fal fa-trash mr-1"></i> Ta bort</button>
      </div>

      <div class="row">
        <div class="col-md-4">
          <input type="text" :name="`contacts[${idx}][name]`" v-model="contact.name" class="form-control mb-3" placeholder="Namn" required>
        </div>
        <div class="col-md-4">
          <input type="tel" :name="`contacts[${idx}][phone]`" v-model="contact.phone" class="form-control mb-3" placeholder="Mobilnummer" minlength=5>
        </div>
        <div class="col-md-4">
          <input type="email" :name="`contacts[${idx}][email]`" v-model="contact.email" class="form-control mb-3" placeholder="E-post">
        </div>
      </div>
    </div>

    <a type="button" class="float-right text-dark" :class="contacts.length == 0 ? 'mt-2' : ''" @click="newContact"><i class="fal fa-smile-plus"></i></a>
  </fieldset>
</template>

<style lang="scss" scoped>
</style>

<script setup>
import { onMounted, ref } from "vue";
const props = defineProps({
    initialContacts: {
        type: Array,
        default: () => [],
    },
});
const send_type = ref(null);
const contacts = ref((Array.isArray(props.initialContacts) ? props.initialContacts : [])
    .filter((contact) => contact && typeof contact === "object")
    .map((contact) => ({
        name: contact.name ?? "",
        phone: contact.phone ?? "",
        email: contact.email ?? "",
    })));
function newContact() {
    contacts.value.push({
        name: "",
        phone: "",
        email: "",
    });
}
function deleteContact(idx) {
    contacts.value.splice(idx, 1);
}
onMounted(() => {
    const targets = Array.from(
        document.querySelectorAll(`input[name="send_type"]`)
    );
    const updateSendType = () => {
        const checked = targets.find((t) => t.checked);
        send_type.value = checked ? checked.value : null;
    };
    window.jQuery(targets).on("input", updateSendType);
});
</script>
